import { render } from "./LbrxSingleWeekCalendar.vue?vue&type=template&id=2200321b&scoped=true"
import script from "./LbrxSingleWeekCalendar.vue?vue&type=script&lang=js"
export * from "./LbrxSingleWeekCalendar.vue?vue&type=script&lang=js"

import "./LbrxSingleWeekCalendar.vue?vue&type=style&index=0&id=2200321b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2200321b"]])

export default __exports__